import { EdgeProps, NodeProps, XYPosition } from 'reactflow'

import { EdgeName } from 'pages/editorPage/data'
import { AuthStatus, User } from 'shared/types'
import { IConnector } from 'shared/types/connector.type'

export enum PresCategories {
  ALL = 'all',
  OWN = 'own',
  FAVORITE = 'fav',
}
export interface IAuthStore {
  authStatus: AuthStatus
  user: User | null
}

export interface IMouseDown {
  isMouseDown: boolean
}

export interface IZoomPopupStore {
  zoomPopup: string | null
  setZoomPopup: (newZoomPopup: string | null) => void
}
export interface IConnectorsStore {
  connectors: Record<string, IConnector>
  setConnectors: (newConnectors: Record<string, IConnector>, updateCurrentValue: boolean) => void
}
export interface IPrewiewsStore {
  previewsLineView: boolean
  setPreviewsLineView: (newPreviewsLineView: boolean) => void
}
export interface ISimplifiedSlidesViewStore {
  simplifiedSlidesView: boolean
  setSimplifiedSlidesView: (newSimplifiedSlidesView: boolean) => void
  toggleSimplifiedSlidesView: () => void
}

export interface IClientsStore {
  clients: Record<string, string>
  setClients: (newClients: Record<string, string>) => void
}

//export interface IContextMenuData {
//  x: number
//  y: number
//  data: string | null
//}
export interface IContextMenuStore {
  contextMenuTarget: NodeProps | null
  contextMenuPosition: XYPosition | null
  closeContextMenu: () => void
}

export interface ISelectionRectStore {
  rectSize: { width: number; height: number }
  setRectSize: (newRectSize: { width: number; height: number }) => void
  selectedData: { nodes: string[]; edges: string[] } | null
}
export interface ISelectionRectStoreData {
  rectSize?: { width: number; height: number }
  selectedData?: { nodes: string[]; edges: string[] } | null
}

export interface IPresCategoryStore {
  presCategory: PresCategories
  setPresCategory: (presCategory: PresCategories) => void
}

export type CopiedNodeData = {
  id: string
  data: {
    label: string
    preview?: string
  }
  type: string
  presId?: string
}
export type CopiedEdgeData = {
  sourceNodeId: string
  targetNodeId: string
  data?: string
  label?: string
}

export type CopiedGroupData = {
  parentNode: CopiedNodeData | null
  childNodes: CopiedNodeData[]
  relativePos?: XYPosition
}

export type HoverableEdgeData = {
  id: string
  data: {
    label: string
  }
  type: EdgeName.CUSTOME_EDGE
}

export interface IHoverStore {
  hoverElement: NodeProps | HoverableEdgeData | null
  setHoverElement: (hoverElement: NodeProps | HoverableEdgeData | null) => void
}

export type SearchData = {
  query?: string | null
  client?: string | null
  owner?: string | null
}

export interface ISearchStore {
  searchData: SearchData
  setSearchData: (newData: SearchData) => void
}

export interface ISelectedEdgeStore {
  selectedEdgeId: string | null
  setSelectedEdgeId: (newSelectedEdgeId: string | null) => void
}
